// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/styles/injected-style-fullscreen.global.scss
// module id = 445
// module chunks = 29